import { useLocation } from 'react-router-dom';

import { useRole } from './useRole';
import { Request } from '../models/request.types';
import type { Status, PaymentStatus } from '../models/request.types';
import type { PaymentSummaryProps } from '../models';

interface UseRequestRulesArgs {
	data?: {
		status: Status;
		paymentStatus?: PaymentStatus;
	};
	paymentSummary?: Pick<PaymentSummaryProps, 'remaining'>;
}

export const useRequestRules = ({ data, paymentSummary }: UseRequestRulesArgs = {}) => {
	const { isUser, isAdmin, isStaff } = useRole();
	const { pathname } = useLocation();

	const allowQtyEditing = data ? getAllowQtyEditing(pathname, isAdmin, isStaff, isUser, data.paymentStatus) : false;

	const allowPayment = Boolean(
		data && paymentSummary && paymentSummary.remaining > 0 && data.status !== Request.status.cancelled,
	);

	const allowCancellation = Boolean(
		data &&
			[Request.status.readyForPayment, Request.status.readyForSchedule, Request.status.readyForAssessment].includes(
				data.status,
			),
	);

	return {
		allowQtyEditing,
		allowPayment,
		allowCancellation,
	};
};

function getAllowQtyEditing(
	pathname: string,
	isAdmin: boolean,
	isStaff: boolean,
	isUser: boolean,
	status: string | undefined,
) {
	if (pathname.includes('new')) return true;

	if (isAdmin || isStaff) return true;

	if (isUser && status === Request.paymentStatus.unpaid) return true;

	return false;
}
